var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import invoke from 'lodash-es/invoke';
import isEqual from 'lodash-es/isEqual';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { styledComponents } from '@datashop/theme';
import { positionHelper } from '@datashop/utils';
var styled = styledComponents.default;
var getPosition = positionHelper.getPosition, isInViewport = positionHelper.isInViewport;
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  z-index: 2147483600;\n"], ["\n  position: relative;\n  display: inline-block;\n  z-index: 2147483600;\n"])));
var PopupContainerWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n"], ["\n  position: relative;\n  display: inline-block;\n"])));
var OnEvents;
(function (OnEvents) {
    OnEvents[OnEvents["click"] = 0] = "click";
    OnEvents[OnEvents["hover"] = 1] = "hover";
})(OnEvents || (OnEvents = {}));
var Position;
(function (Position) {
    Position[Position["TopLeft"] = 0] = "TopLeft";
    Position[Position["TopCenter"] = 1] = "TopCenter";
    Position[Position["TopRight"] = 2] = "TopRight";
    Position[Position["RightCenter"] = 3] = "RightCenter";
    Position[Position["BottomRight"] = 4] = "BottomRight";
    Position[Position["BottomCenter"] = 5] = "BottomCenter";
    Position[Position["BottomLeft"] = 6] = "BottomLeft";
    Position[Position["LeftCenter"] = 7] = "LeftCenter";
})(Position || (Position = {}));
var findDOMNode = function (ref) {
    return ReactDOM.findDOMNode(ref.current);
};
var Popup = (function (_super) {
    __extends(Popup, _super);
    function Popup(props) {
        var _this = _super.call(this, props) || this;
        _this.style = {
            position: 'absolute',
            display: 'inline-block',
        };
        _this.state = {
            position: {
                top: 0,
                left: 0,
            },
            style: {},
        };
        _this.getPopupPosition = function (position) {
            var _a = _this.props, verticalOffset = _a.verticalOffset, horizontalOffset = _a.horizontalOffset;
            return getPosition(position, findDOMNode(_this.triggerRef), findDOMNode(_this.popupRef), {
                vertical: verticalOffset,
                horizontal: horizontalOffset,
            }, !!_this.props.appendToBody);
        };
        _this.setPopupStyle = function () {
            if (!_this.popupRef.current) {
                return;
            }
            var appendToBody = _this.props.appendToBody;
            var position = _this.getPopupPosition(_this.props.position);
            var tempPosition;
            var positionFound = false;
            var initialPositionIndex = Position[_this.props.position];
            var popupElement = findDOMNode(_this.popupRef);
            var triggerElement = findDOMNode(_this.triggerRef);
            if (!isInViewport(popupElement, position, appendToBody, triggerElement)) {
                for (var i = 0; i < 7; i++) {
                    tempPosition = _this.getPopupPosition(Position[(initialPositionIndex + i + 1) % 8]);
                    if (isInViewport(popupElement, tempPosition, appendToBody, triggerElement)) {
                        position = tempPosition;
                        positionFound = true;
                        break;
                    }
                }
            }
            else {
                positionFound = true;
            }
            if (!positionFound) {
                position = _this.getPopupPosition('BottomLeft');
            }
            var style = __assign({}, _this.style, { left: position.left + 'px', top: position.top + 'px' });
            if (isEqual(style, _this.state.style)) {
                return;
            }
            _this.setState({ style: style });
        };
        _this.setPosition = function () {
            if (_this.triggerRef) {
                _this.setPopupStyle();
            }
        };
        _this.handlePortalMount = function () {
            _this.setPosition();
        };
        _this.handleMouseEnter = function (event) {
            if (_this.mouseLeaveTimer) {
                clearTimeout(_this.mouseLeaveTimer);
                _this.mouseLeaveTimer = undefined;
            }
            var _a = _this.props, mouseEnterDelay = _a.mouseEnterDelay, open = _a.open;
            if (!_this.mouseEnterTimer && !open) {
                _this.mouseEnterTimer = window.setTimeout(function () {
                    invoke(_this.props, 'onToggle', true);
                }, mouseEnterDelay || 0);
            }
            invoke(_this.props.trigger.props, 'onMouseEnter', event);
        };
        _this.handleMouseLeave = function (event) {
            if (_this.mouseEnterTimer) {
                clearTimeout(_this.mouseEnterTimer);
                _this.mouseEnterTimer = undefined;
            }
            var mouseLeaveDelay = _this.props.mouseLeaveDelay;
            if (!_this.mouseLeaveTimer) {
                _this.mouseLeaveTimer = window.setTimeout(function () {
                    invoke(_this.props, 'onToggle', false);
                }, mouseLeaveDelay);
            }
            invoke(_this.props.trigger.props, 'onMouseLeave', event);
        };
        _this.handlePopupMouseEnter = function () {
            var _a = _this.props, hoverable = _a.hoverable, on = _a.on, open = _a.open;
            if (on === 'hover' && hoverable && open) {
                if (_this.mouseLeaveTimer) {
                    clearTimeout(_this.mouseLeaveTimer);
                    _this.mouseLeaveTimer = undefined;
                }
            }
        };
        _this.handlePopupMouseLeave = function () {
            var _a = _this.props, hoverable = _a.hoverable, on = _a.on, open = _a.open, mouseLeaveDelay = _a.mouseLeaveDelay;
            if (on === 'hover' && hoverable && open) {
                if (!_this.mouseLeaveTimer) {
                    _this.mouseLeaveTimer = window.setTimeout(function () {
                        invoke(_this.props, 'onToggle', false);
                    }, mouseLeaveDelay);
                }
            }
        };
        _this.handleTriggerToggle = function (event) {
            invoke(_this.props, 'onToggle', !_this.props.open);
            if (_this.props.on === 'click') {
                invoke(_this.props.trigger.props, 'onClick', event);
            }
        };
        _this.getTriggerProps = function () {
            var triggerProps = {};
            var on = _this.props.on;
            if (on === 'click') {
                triggerProps.onClick = _this.handleTriggerToggle;
            }
            if (on === 'hover') {
                triggerProps.onMouseEnter = _this.handleMouseEnter;
                triggerProps.onMouseLeave = _this.handleMouseLeave;
            }
            return triggerProps;
        };
        _this.getPopupProps = function () {
            var popupProps = {};
            var _a = _this.props, on = _a.on, hoverable = _a.hoverable;
            if (on === 'hover' && hoverable) {
                popupProps.onMouseEnter = _this.handlePopupMouseEnter;
                popupProps.onMouseLeave = _this.handlePopupMouseLeave;
            }
            return popupProps;
        };
        _this.doesNodeContainClick = function (event) {
            if (!(findDOMNode(_this.popupRef).contains(event.target) ||
                findDOMNode(_this.triggerRef).contains(event.target))) {
                _this.handleTriggerToggle(event);
            }
        };
        _this.triggerRef = React.createRef();
        _this.popupRef = React.createRef();
        _this.mountNode = document.body;
        return _this;
    }
    Popup.prototype.componentWillUnmount = function () {
        if (this.mouseEnterTimer) {
            clearTimeout(this.mouseEnterTimer);
        }
        if (this.mouseLeaveTimer) {
            clearTimeout(this.mouseLeaveTimer);
        }
        document.removeEventListener('mousedown', this.doesNodeContainClick);
    };
    Popup.prototype.componentDidMount = function () {
        this.handlePortalMount();
        var _a = this.props, on = _a.on, open = _a.open, closeOnBackdropClick = _a.closeOnBackdropClick;
        if (on === 'click' && open && closeOnBackdropClick) {
            document.addEventListener('mousedown', this.doesNodeContainClick);
        }
    };
    Popup.prototype.componentDidUpdate = function () {
        var _a = this.props, on = _a.on, open = _a.open, closeOnBackdropClick = _a.closeOnBackdropClick;
        if (open) {
            this.handlePortalMount();
        }
        if (on === 'click' && open && closeOnBackdropClick) {
            document.addEventListener('mousedown', this.doesNodeContainClick);
        }
        else if (on === 'click' && !open && closeOnBackdropClick) {
            document.removeEventListener('mousedown', this.doesNodeContainClick);
        }
    };
    Popup.prototype.render = function () {
        var _a = this.props, children = _a.children, trigger = _a.trigger, open = _a.open, appendToBody = _a.appendToBody;
        var popup = (React.createElement(Wrapper, __assign({ style: this.state.style, innerRef: this.popupRef }, this.getPopupProps()), children));
        var popupWrapper = (React.createElement(React.Fragment, null,
            React.cloneElement(trigger, __assign({ ref: this.triggerRef }, this.getTriggerProps())),
            open && ReactDOM.createPortal(popup, this.mountNode)));
        if (appendToBody) {
            return popupWrapper;
        }
        else {
            return (React.createElement(PopupContainerWrapper, null,
                React.cloneElement(trigger, __assign({ ref: this.triggerRef }, this.getTriggerProps())),
                !appendToBody && open && popup));
        }
    };
    Popup.defaultProps = {
        closeOnBackdropClick: true,
        horizontalOffset: 0,
        hoverable: false,
        mountNode: document.body,
        mouseLeaveDelay: 50,
        mouseEnterDelay: 0,
        on: 'click',
        open: false,
        position: 'BottomRight',
        verticalOffset: 0,
        appendToBody: true,
    };
    return Popup;
}(React.Component));
export { OnEvents, Position };
export default Popup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Popup.js.map